import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserId } from "../../features/auth/auth-slice";
import { apiSlice } from "../../api/api-slice";
import { socketSetup } from "../../library/socket-io/socket-setup";

interface SocketPayload {
    userId: number;
}

export const useUsersSocket = () => {
    
    const dispatch = useDispatch();
    const currentUserId = useSelector(selectUserId);

    const invalidate = useCallback(
        ({ userId }: SocketPayload) => {
            // Refresh all user-related lists
            dispatch(
                apiSlice.util.invalidateTags([
                    { type: "User", id: "LIST" },
                ])
            );

            // Ignore user-specific updates for other users
            if (userId !== currentUserId) return;

            // Refresh currently logged-in user's details
            dispatch(
                apiSlice.util.invalidateTags([
                    { type: "User", id: userId },
                ])
            );
        },
        [dispatch, currentUserId]
    );

    useEffect(() => {
        if (!socketSetup) return;

        const events = [
            "register",
            "updateProfile",
            "adminUpdateUser",
            "deactivateAccount",
            "activateAccount",
            "resetPassword",
            "adminResetPassword",
        ];

        events.forEach((event) => {
            socketSetup.on(event, invalidate);
        });

        return () => {
            events.forEach((event) => {
                socketSetup.off(event, invalidate);
            });
        };
    }, [invalidate]);
};